
let Api = {
    "N_INDUSTRYMAGE_FINDTREE": '/portal-api/n/industryArticleClassMage/findIndustryArticleClassMageTree',//查询文章分类树
    "N_INDUSTRYMAGE_SEARCHFINDTREE": '/portal-api/n/industryArticleMage/searchFindPageList',//查询文章列表
    "RETRO_CHECKRETROCODE": "/retro/n/checkRetroCode", //追溯码查询接口
    
}
module.exports = Api